import { useQuery } from "@tanstack/react-query";

import useDispatchStore from "@web-app/store/dispatchStore";
import { AppFilterType } from "@web-app/types";

import { getOrdersCount } from "../services/orders";

export const useOrdersCount = (customFilter?: AppFilterType) => {
  const { appFilter } = useDispatchStore();
  const filterToUse = customFilter || appFilter;

  return useQuery({
    queryFn: async ({ signal }) =>
      await getOrdersCount({ payload: filterToUse, signal }),
    queryKey: ["ordersCount", filterToUse],
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
